
import { IIconsProps } from "components/Icons/icons.model"

const CustomUserSettings = (props: IIconsProps) => {
    return (
        <i id={props.id} className="fa-solid fa-users-gear" style={{ fontSize: props.fontSize, color: props.color, ...props.style }} />
    )
}

export default CustomUserSettings;


